import {useMessages} from "i18n";
import PrivateRoute from "../PrivateRoute";
import Seo from "../seo/Seo";
import {PERSONALIZATION_ROUTE} from "../account/brand/personalizationRoute";

/**
 * Private "/personalization" route (kitecorp/transferify-ui#1292) — the URL half of the top bar's
 * Personalization sheet.
 *
 * It renders NO body, and that is the design rather than an omission. The sheet itself is CHROME: a
 * single {@link ../account/brand/BrandSheet} mounted by {@link ../nav/normal/NavBar} beside the bar's
 * other overlays, because the bar owns the two openers whose focus this surface must return to (the
 * pill, and the ProfileMenu row that unmounts with its popover — ui#451). Moving the sheet into this
 * element would put it out of reach of that capture and drop a keyboard user at `<body>` on close.
 *
 * What this element contributes is everything a route owes that chrome cannot: the authenticated gate
 * — login only, exactly as `/account` gates (#12), so a freshly-signed-up FREE sender reaches it — and
 * the noindex metadata every private route carries. Without the record, `routes.tsx`'s `*` fallback
 * would send the URL straight back to "/" and the surface would have no address at all.
 *
 * Bodyless is also why the gate's undecided frame is `fallback={null}` here (ui#2210). The panel
 * routes stand in for a body with the in-panel skeleton; this one has none, so the default would put
 * a ghost card on screen where the route is supposed to render nothing at all.
 *
 * EAGER, unlike the four lazy private routes. Their laziness buys real bundle weight (heavy P2P and
 * account code); this module is a gate plus a `<Seo>`, and the editor it addresses is already in the
 * eager bundle through NavBar's own import of the sheet — so a chunk here would cost a round trip on
 * open and save nothing.
 */
export function Component() {
	const {seo} = useMessages();
	return (
		<PrivateRoute fallback={null}>
			<Seo
				title={seo.personalization.title}
				description={seo.personalization.description}
				path={PERSONALIZATION_ROUTE}
				noindex
			/>
		</PrivateRoute>
	);
}
